import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


class UserSignupModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                callRender: false,                                             
              }  
      this.dataValidSw = true; 
      this.errArray = [{textType: "", message:""},
        {textType: "", message:""},
        {textType: "", message:""},
        {textType: "", message:""},
       ]
  }
 
  editInput(){
    this.dataValidSw = true;
    this.initializeErrorArray();
    this.getFormFields();
    this.editFirstName();
    this.editEmailAddress();
    this.editGradeLevel();
    this.editPrimaryRole();
    if ( this.dataValidSw === true){
        this.saveUserSignupInfo();
        this.props.onSubmit(this.contactUsObj);
    }else{
        this.setState({callRender: true});
    }
  }

  initializeErrorArray(){
    this.errArray =[{textType: "", message:""},
        {textType: "", message:""},
        {textType: "", message:""},
        {textType: "", message:""},
        ]
  }

  getFormFields(){
       this.firstName = document.getElementById("firstName").value;
       this.gradeLevel = document.getElementById("gradeLevel").value;
       this.emailAddress = document.getElementById("emailAddress").value;
       this.primaryRole = document.getElementById("primaryRole").value;
  }
  
  editFirstName(){
    var validFirstName = true;
    if (this.firstName.length === 0){
        validFirstName = false;
    }else{
        // edit to see if name is a string of same character
        const charArray = this.firstName.split('');
        const firstChar = charArray[0];
        var i;
        var counter = 1;
        for (i=1; i<charArray.length; i++){
            if (charArray[i] === firstChar) {
                counter = counter + 1;
            }
        }
        if (counter === charArray.length){
            validFirstName = false;
        }
    }
    if (validFirstName === false){
        this.errArray[0] = {textType: "text-danger", message: "Required"}
         this.dataValidSw = false;
    }
  }

  editGradeLevel() {
    if (this.gradeLevel === "none"){
      this.errArray[1] = {textType: "text-danger", message: "Required"}
      this.dataValidSw = false;
    }
  }

  editEmailAddress() {
    var validEmailAddress = true;
    if (this.emailAddress.length === 0){
         validEmailAddress = false;
    }else{
        if (this.emailAddress.indexOf('@') <= 0){
          validEmailAddress = false;
        }
    }
    if (validEmailAddress === false){
       this.errArray[1] = {textType: "text-danger", message: "Enter a valid Email Address"};
        this.dataValidSw = false;
    }
  }

  editPrimaryRole(){
      var validPrimaryRole = true;
      if (this.primaryRole === "none"){
           validPrimaryRole = false;
      }
      if (validPrimaryRole === false){
          this.errArray[3] = {textType: "text-danger", message: "Select a Primary Role"};
           this.dataValidSw = false;
      }
      if (validPrimaryRole === true){
          switch (this.primaryRole){
              case "teacher":
                this.codeType = "Class Code";
                break;
              case "parent":
                this.codeType = "Family Code";
                break;
              default:
                this.codeType = "Unknown Code";
                break;
          }
      }
  }

  saveUserSignupInfo(){
      const formData = {primaryRole: this.primaryRole,  
        gradeLevel: this.gradeLevel };
      const messageText = "Request to add a new " + this.codeType + " for " + this.firstName;
      this.contactUsObj = {rqstType: "UserSignon", firstName: this.firstName, emailAddress: this.emailAddress,
        subject: "Requesting Access to the Game", message: messageText, emailType: "AccountRequest",
        formData: formData};
    }
   
    render() {
                                        
    return <>
      
      <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
            size="med" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title>Request Access to the Game for a Parent or Teacher</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="text-left">
               Access to the game is free at this time.  Use the form below to let us know if you
               would like to setup a Parent Portal or a Teacher Portal.  We will review your request
               and reply to the email address provided within a day or two.
            </div>
           
            <div className="text-left mt-2">
                <p>Please complete all fields on this form and then click 
                   'Submit'.</p>
                <div >
                   <label className="font-weight-bold" htmlFor="firstName">
                        First Name:&nbsp;&nbsp;</label>
                   <input type="text" className="col-med" id="firstName" name="firstName"></input> 
                   <span className={this.errArray[0].textType}>
                          &nbsp;{this.errArray[0].message}</span>
                </div>
                <div className="mt-4">
                  <label className="font-weight-bold" htmlFor="gradeLevel">Player Grade Level:&nbsp;&nbsp;</label>
                  
                  <select 
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="gradeLevel">
                        <option value="none">no grade level slctd</option>
                        <option value="Elementary">Elementary School</option>
                        <option value="MiddleSchool">Middle or Junior High School</option>
                        <option value="HighSchool">High School</option>
                  </select>
                  <span className={this.errArray[1].textType}>
                          &nbsp;{this.errArray[1].message}</span>
                </div>
                <div >
                  <label className="font-weight-bold" htmlFor="emailAddress">Email Address:&nbsp;&nbsp;</label>
                  <span className={this.errArray[2].textType}>
                          &nbsp;{this.errArray[2].message}</span>
                  <input type="text" className="col-lg" id="emailAddress" name="emailAddress"></input>   
                </div>
                <div className="mt-4">
                  <label className="font-weight-bold" htmlFor="primaryRole">Primary Role:&nbsp;&nbsp;</label>
                  
                  <select 
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="primaryRole">
                        <option value="none">no primary role slctd</option>
                        <option value="parent">Parent</option>
                        <option value="teacher">Teacher</option>
                  </select>
                  <span className={this.errArray[3].textType}>
                          &nbsp;{this.errArray[3].message}</span>
                </div>
                               
            </div>
           </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
          <div className="font-weight-bold">Parent/Teacher accounts are intended for adults.
          </div>
          { this.dataValidSw ?
            <div></div>
          :
            <div className="text-danger">Please Correct errors and try-again.</div>
          }
          <div>
            <Button variant="secondary"   onClick={() => this.props.onClose()}>
                Close
            </Button>
            <Button className="ml-4" variant="primary"  onClick={() => this.editInput()}>
                Submit
            </Button>
          </div>
        </Modal.Footer>
        </Modal>
      
        </>
    }

}

export default UserSignupModal;